import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { AlignJustifyStyle } from '../../model/AlignJustifyStyle.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Img } from '../../ui-kit/Img/Img.js';
import { style } from '../../utils/style.js';
export const ImgBlock = JSX((props) => {
    const { className, align, image, ...rest } = props;
    const alignStyle = align ? style('flex', AlignJustifyStyle[align]) : '';
    return (_jsx(BlockWrapper, { className: style(alignStyle, className), defaultPadding: "p-0", ...rest, children: _jsx(Img, { image: image }) }));
});
//# sourceMappingURL=ImgBlock.js.map